import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/breakDownTasksActions";
import * as api from "../../api/breakDownTaskApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import moment from "moment";

function* getPoolList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPoolList();
        yield put(actions.setPoolList(data || undefined));
        if (action?.payload?.shouldFireStatus) {
            yield put(actions.getStatusList());
        }
    } catch (error) {
        yield put(actions.setPoolList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUnPlannedMaintenanceList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUnPlannedMaintenanceList(action.payload);
        if (action?.payload?.dataHandlerAfterStatusChanged) {
            yield put(actions.setUnPlannedMaintenanceList({ statusChangedRes: data } || undefined));
        }
        if (action?.payload?.fetchMoreData) {
            yield put(actions.setUnPlannedMaintenanceList({ fetchMoreDataRes: data } || undefined));
        }
        if (action?.payload?.applyFilterRes) {
            yield put(actions.setUnPlannedMaintenanceList({ applyFilterRes: data } || undefined));
        }
        if (action?.payload?.handleStatusRes) {
            yield put(actions.setUnPlannedMaintenanceList({ handleStatusRes: data } || undefined));
        }
        if (action?.payload?.handlePoolRes) {
            yield put(actions.setUnPlannedMaintenanceList({ handlePoolRes: data } || undefined));
        }
        if (action?.payload?.handleAssignMe) {
            yield put(actions.setUnPlannedMaintenanceList({ handleAssignMe: data } || undefined));
        }
        if (action?.payload?.firstCall) {
            yield put(actions.setUnPlannedMaintenanceList({ firstCallRes: data } || undefined));
        }
        if (action?.payload?.applyRefreshRes) {
            yield put(actions.setUnPlannedMaintenanceList({ applyRefreshRes: data } || undefined));
        }
        // yield put(actions.getPoolList())
    } catch (error) {
        yield put(actions.setUnPlannedMaintenanceList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUnPlannedMaintenanceListMultiple(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUnPlannedMaintenanceListMultiple(action.payload);
        if (action?.payload?.dataHandlerAfterStatusChanged) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ statusChangedRes: data } || undefined));
        }
        if (action?.payload?.fetchMoreData) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ fetchMoreDataRes: data } || undefined));
        }
        if (action?.payload?.applyFilterRes) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ applyFilterRes: data } || undefined));
        }
        if (action?.payload?.handleStatusRes) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ handleStatusRes: data } || undefined));
        }
        if (action?.payload?.handlePoolRes) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ handlePoolRes: data } || undefined));
        }
        if (action?.payload?.handleAssignMe) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ handleAssignMe: data } || undefined));
        }
        if (action?.payload?.firstCall) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ firstCallRes: data } || undefined));
        }
        if (action?.payload?.applyRefreshRes) {
            yield put(actions.setUnPlannedMaintenanceListMultiple({ applyRefreshRes: data } || undefined));
        }
        // yield put(actions.getPoolList())
    } catch (error) {
        yield put(actions.setUnPlannedMaintenanceListMultiple(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
        yield put(actions.setAreaListToNull());
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
}

// getTechList

function* getTechList(action) {
    try {
        const data = yield api.getTechList();
        if (action?.payload?.filterRes) {
            yield put(actions.setTechList({ filterRes: data } || undefined));
        } else {
            yield put(actions.setTechList(data || undefined));
        }
    } catch (error) {
        yield put(actions.setTechList(undefined));
        yield put(showErrorSnackbar(error));
    }
}

function* getStatusList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getStatusList();
        // console.log({ data })
        yield put(actions.setStatusList(data || undefined));
    } catch (error) {
        yield put(actions.setStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getActiveCounts(action) {
    try {
        const { data } = yield api.getActiveCounts();
        if (action.payload?.statusWithTimer) {
            yield put(actions.setActiveCounts({ response: data } || undefined));
        } else {
            yield put(actions.setActiveCounts(data || undefined));
        }
    } catch (error) {
        yield put(actions.setActiveCounts(undefined));
        yield put(showErrorSnackbar(error));
    }
}

function* getEquipmentMainList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEquipmentMainList(action.payload);
        yield put(actions.setEquipmentMainList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentMainList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentSubList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEquipmentSubList(action.payload);
        yield put(actions.setEquipmentSubList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentSubList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getReasonGroup() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getReasonGroup();
        yield put(actions.setReasonGroup(data || undefined));
        yield put(actions.getEffects());
    } catch (error) {
        yield put(actions.setReasonGroup(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEffects() {
    try {
        const { data } = yield api.getEffects();
        yield put(actions.setEffects(data || undefined));
    } catch (error) {
        yield put(actions.setEffects(undefined));
        yield put(showErrorSnackbar(error));
    }
}

function* getCostCenterList() {
    try {
        const { data } = yield api.getCostCenterList();
        yield put(actions.setCostCenterList(data));
    } catch (error) {
        yield put(actions.setCostCenterList(undefined));
        yield put(showErrorSnackbar(error));
    }
}

function* downloadExcelFile(action) {
    try {
        const { data } = yield api.downloadExcelFile(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_BreakdownTasks_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_EXCEL, downloadExcelFile);
    yield takeEvery(actions.Types.GET_REASON_GROUP, getReasonGroup);
    yield takeEvery(actions.Types.GET_EFFECTS, getEffects);
    yield takeEvery(actions.Types.GET_UNPLANNED_MAINTENANCE, getUnPlannedMaintenanceList);
    yield takeEvery(actions.Types.GET_UNPLANNED_MAINTENANCE_MULTIPLE, getUnPlannedMaintenanceListMultiple);
    yield takeEvery(actions.Types.GET_MAINTENANCE_STATUS_LIST, getStatusList);
    yield takeEvery(actions.Types.GET_EQUIPMENT_MAIN_LIST, getEquipmentMainList);
    yield takeEvery(actions.Types.GET_EQUIPMENT_SUB_LIST, getEquipmentSubList);
    yield takeEvery(actions.Types.GET_TECH_LIST, getTechList);
    yield takeEvery(actions.Types.GET_POOL_LIST, getPoolList);
    yield takeEvery(actions.Types.GET_COUNTS, getActiveCounts);
    yield takeEvery(actions.Types.GET_AREAS, getAreaList);
    yield takeEvery(actions.Types.GET_COST_CENTERS, getCostCenterList);
}

const breakDownTaskSagas = [fork(watchAll)];

export default breakDownTaskSagas;
